import { Component, inject, signal } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';
import {
	NgbNavContent,
	NgbNav,
	NgbNavItem,
	NgbNavItemRole,
	NgbNavLinkButton,
	NgbNavLinkBase,
	NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap/nav';

@Component({
  imports: [NgbNavContent, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkButton, NgbNavLinkBase, NgbNavOutlet],
  selector: 'app-agenda',
  styleUrl: './agenda.scss',
  templateUrl: './agenda.html',
})
export class Agenda {
  readonly version = inject(AuthSessionService).paxVersion;
  // GSCS and EDA agendas start on Monday (tab 3); VIP starts on the Saturday travel day (tab 1).
  readonly active = signal(this.version() === 'VIP' ? 1 : 3);
}
